import { render, staticRenderFns } from "./nurseChild.vue?vue&type=template&id=2f365880&scoped=true&"
import script from "./nurseChild.vue?vue&type=script&lang=js&"
export * from "./nurseChild.vue?vue&type=script&lang=js&"
import style0 from "./nurseChild.vue?vue&type=style&index=0&id=2f365880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f365880",
  null
  
)

export default component.exports